import { createFileRoute } from '@tanstack/react-router'
import { requireModule, requirePermission } from '../../app/guards'
import { MyWorkPage } from '../../features/tasks/my-work-page'
import { myWorkSearchSchema } from '../../features/tasks/search'

// The employee's landing page for tasks (ADR-021), while the company has the module.
export const Route = createFileRoute('/_app/my-work')({
  staticData: { crumb: 'myWork' },
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'tasks')
    requirePermission(context.session, 'tasks.read')
  },
  validateSearch: myWorkSearchSchema,
  component: MyWorkPage,
})
